import { TGetSketches } from "../../models";
import { axiosHttpClient } from "../axios";
import handleStatusCases from "../handle-status-cases";

const { REACT_APP_BASE_URL } = process.env;

export default async ({ length, page }: TGetSketches = {}) => {
    const tempParams = {
        length,
        page,
    };

    const httpResponse = await axiosHttpClient({
        url: `${REACT_APP_BASE_URL}/invite/readInviteSketch`,
        method: "get",
        headers: { auth: true },
        params: tempParams,
    });
    const { body, statusCode } = httpResponse;

    const errorFeedBacks = {
        400: "Rascunhos inválidos",
        409: "Usuário já existente/convite já existe para este usuário!",
        500: "Email não verificado",
    };

    return handleStatusCases({
        body,
        statusCode,
        errorFeedBacks,
    });
};
